import { withStyles } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import translations from '../../../translations/i18next';
import MDTextInputField from '../FormsComponents/MDTextInput/MDTextInputField';
import MDCheckBoxField from '../FormsComponents/MDCheckbox/MDCheckBoxField';
import { EDULAI_BLUE } from '../../../styles/styleConsts';

const styles = theme => ({
  cssOutlinedInput: {
    borderColor: 'white',
    color: '#80888F',
    height: 40,
    fontFamily: 'Circular Book !important',
    backgroundColor: 'white',
    '&$cssFocused $notchedOutline': {
      borderColor: 'white',
    },
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
  },
  disabled: {},
  focused: {},
  error: {},
  notchedOutline: {
    borderColor: 'white',
  },
  cssFocused: {},
  inputLabel: {
    fontFamily: 'Circular Book !important',
  },
});

const validate = (values) => {
  const errors = {};
  if (!values.newPassword || (values.newPassword && !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(values.newPassword))) {
    errors.newPassword = translations.t('forms.passwordValidation');
  }
  if (!values.confirmPassword || (values.confirmPassword && values.newPassword && values.confirmPassword !== values.newPassword)) {
    errors.confirmPassword = translations.t('forms.passwordMustCoincide');
  }
  if (!values.privacyPolicy) {
    errors.privacyPolicy = translations.t('forms.required');
  }

  return errors;
};


const ConfirmRegistrationForm = ({ classes, onOpenPrivacyModal }) => (
  <div style={{ marginRight: 0, width: '100%' }}>
    <h4 id="circular-bold-label" style={{ letterSpacing: 1, color: '#80888F', marginBottom: 14, marginLeft: 0, fontSize: 14, marginTop: 26 }}>
      PASSWORD
    </h4>
    <Field
      name="newPassword"
      variant="outlined"
      component={MDTextInputField}
      type="password"
      placeholder={translations.t('login.insertPassword')}
      showErrorLabel
    />
    <h4 id="circular-bold-label" style={{ letterSpacing: 1, color: '#80888F', marginBottom: 14, marginLeft: 0, fontSize: 14, marginTop: 26 }}>
      {translations.t('forms.confirmPasswordTitle').toUpperCase()}
    </h4>
    <Field
      name="confirmPassword"
      component={MDTextInputField}
      type="password"
      variant="outlined"
      placeholder={translations.t('forms.confirmPasswordLabel')}
      showErrorLabel
    />
    <Field
      name="privacyPolicy"
      component={MDCheckBoxField}
      containerstyle={{ marginLeft: 10, marginTop: 15, marginBottom: 40 }}
      label={(
        <div style={{ alignItems: 'center', display: 'flex' }}>
          <h4 id="circular-bold-label"style={{ color: '#3f3f3f', fontSize: 18, margin: 0, marginRight: 5, fontWeight: 100 }}>{translations.t('forms.iAcceptThe')}</h4>
          <h4 id="circular-bold-label" className="link-label" style={{ fontSize: 18, margin: 0, color: EDULAI_BLUE, fontWeight: 100 }} onClick={(e) => onOpenPrivacyModal()}>
            {translations.t('forms.privacyPolicy')}
            <span style={{ color: '#D71F4B' }}>*</span>
          </h4>
        </div>
      )}
      showErrorLabel
    />
  </div>
);

export default connect()(withStyles(styles)(reduxForm({
  form: 'ConfirmRegistrationForm',
  validate,
})(ConfirmRegistrationForm)));
